import script from "./remark-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./remark-group.vue?vue&type=script&setup=true&lang=ts"

import "./remark-group.vue?vue&type=style&index=0&id=f67a2945&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f67a2945"]])

export default __exports__